export default "__VITE_ASSET__B0P6BSwh__"